"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClosedCaptionsMenuButtonControl = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var first_1 = __importDefault(require("lodash/first"));
var last_1 = __importDefault(require("lodash/last"));
var listbox_button_1 = require("../listbox/listbox-button");
var use_subtitles_track_list_1 = require("../../hooks/use-subtitles-track-list");
var ClosedCaptionsMenuButtonControl = function (props) {
    var _a = (0, use_subtitles_track_list_1.useSubtitlesTrackList)(), subtitles = _a.subtitles, activateSubtitlesTrack = _a.activateSubtitlesTrack, clearSubtitlesTracks = _a.clearSubtitlesTracks;
    var items = __spreadArray(__spreadArray([], subtitles.map(function (track) {
        return {
            mode: track.mode,
            value: track.language,
            label: track.label,
        };
    }), true), [
        {
            label: 'Off',
            value: 'off',
        },
    ], false);
    var activeTrack = (0, first_1.default)(items.filter(function (track) { return track.mode === 'showing'; }));
    var activeItem = (0, isEmpty_1.default)(activeTrack)
        ? (0, last_1.default)(items)
        : activeTrack;
    var groups = [
        {
            label: 'Closed Captions',
            items: items,
        },
    ];
    var handleSelectItem = React.useCallback(function (index) {
        var track = subtitles[index];
        (track === null || track === void 0 ? void 0 : track.language) ? activateSubtitlesTrack(track) : clearSubtitlesTracks();
    }, [subtitles]);
    return !(0, isEmpty_1.default)(subtitles) ? (React.createElement("div", { className: "cueplayer-react-closed-caption" },
        React.createElement(listbox_button_1.ListboxButton, { className: (0, classnames_1.default)(props.className), selectedItem: activeItem, onSelectItem: handleSelectItem, items: groups, title: 'Closed captions' },
            React.createElement("span", { className: "cueplayer-react-control-text" },
                activeItem.label,
                " subtitles")))) : null;
};
exports.ClosedCaptionsMenuButtonControl = ClosedCaptionsMenuButtonControl;
